import { render, staticRenderFns } from "./block-claims-insurer.vue?vue&type=template&id=acb6beee&scoped=true&"
import script from "./block-claims-insurer.vue?vue&type=script&lang=js&"
export * from "./block-claims-insurer.vue?vue&type=script&lang=js&"
import style0 from "./block-claims-insurer.vue?vue&type=style&index=0&id=acb6beee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acb6beee",
  null
  
)

export default component.exports